import api from "../../api";

// initial state
const state = {
  data: {
    id: -1,
    components: [],
    user: {
      subscription: {
        active: false
      }
    }
  }
};

// getters
const getters = {
  userOwnsWebsite: (state, getters, rootState) => {
    const user = rootState.user.user;
    if (!user || !user.websites || user.websites.length === 0) return false;
    return user.websites[0].id === state.data.id;
  },

  isWebsitePremium: (state, getters, rootState) => {
    return state.data.user.subscription && state.data.user.subscription.active;
  },

  // Total number of components in a website.
  numComponents: (state, getters, rootState) => {
    return state.data.components.length;
  }
};

// actions
const actions = {
  async getWebsite({ commit }, websiteName) {
    const website = await api.getWebsite(websiteName);
    commit("setWebsite", website);
  }
};

// mutations
const mutations = {
  setWebsite(state, website) {
    state.data = website;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
